import dayjs from 'dayjs';
import { GOOGLE_CLICK_DATE, GOOGLE_CLICK_ID_EXPIRY_DAYS } from '../constants';
import { getGoogleClickIdFromURL } from './getGoogleClickIdFromURL';

export const setGoogleClickIdDateToCookie = (): void => {
  const googleClickId = getGoogleClickIdFromURL();

  if (googleClickId) {
    const expireDate = dayjs().add(GOOGLE_CLICK_ID_EXPIRY_DAYS, 'day').toDate();

    const googleClickIdDate = dayjs().format('MM/DD/YYYY HH:mm:ss');

    document.cookie = `${GOOGLE_CLICK_DATE}=${googleClickIdDate}; expires=${expireDate.toUTCString()}; path=/; SameSite=Lax;`;
  }
};
